import i18n from '../i18n';
import translationIT from './it_translation.json';

// This function can be called early in the app initialization
export function preloadTranslations() {
  // Preload the Italian translations first (default language)
  const savedLanguage = localStorage.getItem('preferredLanguage') || 'it';

  if (!i18n.hasResourceBundle('it', 'translation')) {
    i18n.addResourceBundle('it', 'translation', translationIT, true, true);
  }

  // Set the language explicitly
  i18n.changeLanguage(savedLanguage);

  return savedLanguage;
}
